export enum PageModeEnum {
  Gameshows = 'G',
  Missions = 'M',
  Default = 'D'
}
